import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Text } from '../../atoms/text/text';
import utilityStyles from '../../theme/utilities.module.scss';
import styles from './footnote.module.scss';
export const Footnote = ({ children, className, color, index })=>/*#__PURE__*/ _jsxs(Text, {
        className: classNames('footnote', styles.footnote, color && utilityStyles[`theme-color-${color}`], className),
        renderAs: "div",
        size: "xs",
        children: [
            /*#__PURE__*/ _jsx("sup", {
                children: index
            }),
            /*#__PURE__*/ _jsx("div", {
                children: children
            })
        ]
    });

//# sourceMappingURL=footnote.js.map